// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowUpRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowUpRightIcon" ref={forwardedRef} {...props}>
      <path d="m14.25 5.75-.007 8.5h-1.501l.005-5.88-5.586 5.587-1.06-1.059 5.648-5.647h-6l.002-1.494z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowUpRightIcon = /* @__PURE__ */ Object.assign(
  ArrowUpRightIconComponent,
  { displayName: 'ArrowUpRightIcon' },
);
